"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotEnoughCreditsDialog = NotEnoughCreditsDialog;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_redux_1 = require("react-redux");
const react_intl_1 = require("react-intl");
const react_router_1 = require("react-router");
const actions_1 = __importDefault(require("@src/actions"));
const elements_1 = require("@src/components/elements");
const Api = __importStar(require("@src/api"));
const useBraintree_1 = require("@src/hooks/useBraintree");
const account_context_1 = require("@src/context/account-context");
const types_1 = require("@src/types");
const useAppQuery_1 = require("@src/hooks/useAppQuery");
const queries_1 = require("@src/types/queries");
const admin_context_1 = require("../admin-context");
// TODO make universal
function NotEnoughCreditsDialog({ creditCount = 1 }) {
    const [isPaymentInProgress, setIsPaymentInProgress] = react_1.default.useState(false);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isOpenNotEnoughCreditsDialog, setIsOpenNotEnoughCreditsDialog } = (0, admin_context_1.useAdminContextValue)();
    const intl = (0, react_intl_1.useIntl)();
    const history = (0, react_router_1.useHistory)();
    // @ts-ignore
    const company = (0, react_redux_1.useSelector)(state => state.admin.company);
    const account = (0, account_context_1.useAccount)();
    const { email, telephone, firstName, lastName } = account !== null && account !== void 0 ? account : {};
    const { initCheckout } = (0, useBraintree_1.useBraintree)();
    const formattedTelephone = telephone === null || telephone === void 0 ? void 0 : telephone.replace('+', '00');
    const hasRememberedPaymentMethod = Boolean(company.payment_method_token);
    const goToUpsell = () => {
        history.pushLocalized('/admin/kredity');
        setIsOpenNotEnoughCreditsDialog(false);
    };
    const orderParams = react_1.default.useMemo(() => ({
        productAmounts: [
            {
                productId: types_1.ProductId.offerCredits,
                amount: creditCount,
            },
        ],
        appliedCouponCode: null,
    }), [creditCount]);
    const { data: orderContent, isFetching: isOrderFetching } = (0, useAppQuery_1.useAppQuery)([queries_1.Queries.getOrder, orderParams], () => Api.Admin.getOrderContent({ orderParams }));
    const buyCredits = async () => {
        try {
            setIsPaymentInProgress(true);
            const { braintree3DSecure, braintreeDataCollectorInstance } = await initCheckout(false);
            const paymentMethodData = await Api.Admin.getPaymentMethodNonce();
            const response = await braintree3DSecure.verifyCard({
                // @ts-ignore
                onLookupComplete(data, next) {
                    next();
                },
                // @ts-ignore
                amount: orderContent.totalPrice,
                nonce: paymentMethodData.nonce,
                bin: paymentMethodData.details.bin,
                email,
                mobilePhoneNumber: formattedTelephone,
                challengeRequested: true,
                billingAddress: {
                    givenName: firstName,
                    surname: lastName,
                    phoneNumber: formattedTelephone,
                    streetAddress: company.formatted_address,
                    locality: company.city,
                    postalCode: company.postal_code,
                },
            });
            // @ts-ignore
            if (!response.liabilityShifted) {
                return;
            }
            if (!orderContent) {
                throw new Error(intl.formatMessage({
                    id: 'admin.order.invalid_order',
                }));
            }
            await Api.Admin.buyProductByCard({
                order: orderContent,
                orderParams,
                savePaymentMethod: false,
                // @ts-ignore
                nonce: response.nonce,
                deviceData: braintreeDataCollectorInstance.deviceData,
            });
            setIsOpenNotEnoughCreditsDialog(false);
            dispatch(actions_1.default.myCompanyInfoInitStart());
            antd_1.notification.success({
                message: intl.formatMessage({
                    id: 'admin.not_enough_credits_dialog.credits_replenished',
                }),
                description: intl.formatMessage({
                    id: 'admin.not_enough_credits_dialog.credits_replenished.continue',
                }),
                duration: 30,
            });
        }
        catch (err) {
            console.log(err);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'forms.offer_notification_subscription_form.error',
                    defaultMessage: 'Chyba',
                }),
                description: intl.formatMessage({
                    id: 'forms.offer_notification_subscription_form.something_went_wrong',
                    defaultMessage: 'Niekde nastala chyba.',
                }),
            });
        }
        finally {
            setIsPaymentInProgress(false);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(antd_1.Modal, { onCancel: () => setIsOpenNotEnoughCreditsDialog(false), onOk: () => setIsOpenNotEnoughCreditsDialog(false), visible: isOpenNotEnoughCreditsDialog, title: intl.formatMessage({ id: 'admin.not_enough_credits_dialog.not_enough_credits' }), footer: null, children: [isOrderFetching && (0, jsx_runtime_1.jsx)(elements_1.Spinner, { className: "width-100", size: "large" }), hasRememberedPaymentMethod && !isOrderFetching && orderContent && ((0, jsx_runtime_1.jsxs)("div", { className: "flex-col align-center justify-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "m-b-l font-size-l text-center", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.not_enough_credits_dialog.instant_replenish", values: {
                                creditPrice: intl.formatNumber(orderContent.products[0].totalPrice, {
                                    style: 'currency',
                                    currency: 'EUR',
                                }),
                                strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }),
                            } }) }), (0, jsx_runtime_1.jsx)("img", { style: { width: '160px' }, className: "m-b-xl", src: "/media/illustrations/streamline-icon-circle-coin-sparkle.svg", alt: "" }), (0, jsx_runtime_1.jsx)("div", { className: "flex-row", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { type: "default", className: "m-r-m", onClick: goToUpsell, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.not_enough_credits_dialog.go_to_pricing" }) }) })] })), !hasRememberedPaymentMethod && ((0, jsx_runtime_1.jsxs)("div", { className: "flex-col align-center justify-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "m-b-l font-size-l text-center", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.not_enough_credits_dialog.insufficient_amount_of_credits" }) }), (0, jsx_runtime_1.jsx)("img", { style: { width: '160px' }, className: "m-b-xl", src: "/media/illustrations/streamline-icon-empty-wallet-2.svg", alt: "" }), (0, jsx_runtime_1.jsx)("div", { className: "flex-row", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { onClick: goToUpsell, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.not_enough_credits_dialog.go_to_pricing" }) }) })] }))] }));
}
